import { isPackageOpen } from "./packageDisplay"

import type { PackageFolder, RangePackage } from "./types"

const NOT_ACTIVE_REASON = "This package is inactive, so it can't be changed."
const DELETING_REASON = "This package is marked for deletion. Keep it to change it."
export const ARCHIVED_BY_FOLDER_REASON =
  "Archived with its folder. Restore the folder to change this."

export function isArchivedByFolder(pkg: RangePackage, folders: PackageFolder[]) {
  return folders.find((folder) => folder.id === pkg.folderId)?.deactivated === true
}

export function pageDisabledReason(pkg: RangePackage, folders: PackageFolder[], deleting: boolean) {
  if (deleting) return DELETING_REASON
  if (isPackageOpen(pkg.status)) return undefined
  const undated = pkg.type !== "noos" && (pkg.startDate === null || pkg.cutoffDate === null)
  if (undated && !pkg.ownDeactivated && !isArchivedByFolder(pkg, folders)) return undefined
  return NOT_ACTIVE_REASON
}
